import { jsx } from "panel";
import { SvgIconEl } from "common/components/svg-icon";
import { TagTheme } from "./types";
export function template() {
  const isBreadcrumb = this.attr(`theme`) === TagTheme.Breadcrumb;
  const isRemoveable = !isBreadcrumb && this.attr(`removable`);
  return /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".mp-tag",
      class: {
        clickable: this.attr(`clickable`),
        removable: this.attr(`removable`),
        [this.attr(`theme`)]: true,
        [this.attr(`size`) === this.helpers.TagSize.Small ? `small-tag` : `default-tag`]: true
      },
      on: { click: this.attr(`clickable`) ? this.helpers.select : null }
    },
    this.attr(`icon`) ? /* @__PURE__ */ jsx("div", { sel: ".tag-extra-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: this.attr(`icon`) } })) : null,
    /* @__PURE__ */ jsx("div", { sel: ".tag-name", attrs: { elref: `mpTagName` } }, this.attr(`tag-name`)),
    isBreadcrumb && /* @__PURE__ */ jsx("div", { sel: ".tag-caret-icon" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `caret-right` } })),
    isRemoveable && /* @__PURE__ */ jsx("div", { sel: ".tag-remove-icon", on: { click: this.helpers.remove } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `x` } }))
  );
}
